module.exports = __webpack_public_path__ + "static/automne-10ed05d9ce034a1123a221ad530ec8e8.jpg";